import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import ViewModel from '@bingads-webui-component-legacy/object-list-input/viewmodel/index';
import template from '@bingads-webui-component-legacy/object-list-input/template/index.pug';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!component/object-list-input');

export default class View extends Backbone.View {
  initialize(options = {}) {
    this.options = _.defaults(options, {
      minItems: -1,
      maxItems: -1,
      View: Backbone.View,
      values: [],
      headerTemplate: '',
      footerTemplate: '',
    });

    this.koModel = new ViewModel(this.options);
  }

  render() {
    this.$el.html(template({
      i18n,
      headerTemplate: this.options.headerTemplate,
      footerTemplate: this.options.footerTemplate,
    }));
    ko.applyBindings(this.koModel, this.el);
    return this;
  }
}
